import { FilterFieldsType } from '@/types';

type FilterValue = {
  urlId: string;
  value: string;
};

export const getFilterDisplayValue = (
  code: string,
  value: string,
  filters: FilterFieldsType,
): { name: string; value: string } => {
  const filter = filters[code];

  if (!filter) {
    return { name: code, value };
  }

  const filterValue = Array.isArray(filter.values)
    ? filter.values.find(
        (item: FilterValue) => item.urlId === value || item.value === value,
      )
    : null;

  return {
    name: filter.name,
    value: filterValue?.value || value,
  };
};
